import React, { Component, Fragment } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import Login from '../../assets/images/login.png'
import { Link, Navigate } from 'react-router-dom'
import AppURL from '../../api/AppURL';
import axios from 'axios'

class UserLogin extends Component {

     constructor() {
          super();
          this.state = {
               email: '',
               password: '',
               message: '',
               loggedIn: false
          }
     }

     //setUser: এটি একটি ফাংশন যা প্যারেন্ট কম্পোনেন্ট থেকে পাঠানো হয় এবং ইউজারের তথ্য সেট করার জন্য ব্যবহৃত হয়।
     //UserLoginPage এর setUser এবং user প্রপ্সগুলো UserLogin এ পাঠানো হয়েছে।
     //UserLogin এ axios রিকোয়েস্টের মাধ্যমে লগইন সফল হলে, ইউজারের তথ্য (response.data.user) পাওয়া যাবে।
     //এরপর UserLoginPage থেকে আসা setUser ফাংশনটিকে কল করে, this.props.setUser(response.data.user) ইউজারের তথ্য সেট করা হচ্ছে, যা পরে 
     //অ্যাপ্লিকেশনের অন্যান্য অংশেও ব্রাউজ করার জন্য ব্যবহারযোগ্য হবে।
     //লগইন করার পর profile এ রিডিরেক্ট হয় আর তাই সেখানে প্রোফাইলের তথ্য থাকা প্রয়োজন যেমন নাম, 
     //ইমেইল আর সেই ইউজার ডাটা Approute থেকে আগেই axios দিয়ে কল করে ধারণ করা হয় এবং props এর মাধ্যমে user এবং setuser ইউজার ব্যবহার করে UserLogin পেজে পাস করা হয় এবং 
     //UserLogin থেকে axios দিয়ে কল করে রেস্পনসকে এভাবে this.props.setUser(response.data.user); setUser এর মধ্যে সেটাপ করা হয়




     // Login Form Submit Method 
     formSubmit = (e) => {
          e.preventDefault();
          const data = {
               email: this.state.email,
               password: this.state.password
          }

          axios.post(AppURL.UserLogin, data).then(response => {

               localStorage.setItem('token', response.data.token);
               localStorage.setItem('email', response.data.user.email);
               this.setState({ loggedIn: true })
               this.props.setUser(response.data.user);

          }).catch(error => {

          });

     }



     render() {

          // After Login Redirect to Profile Page 
          if (this.state.loggedIn) {
               return <Navigate to={'/profile'} />
          }

          if (localStorage.getItem('token')) {
               return <Navigate to="/profile" />
          }


          return (
               <Fragment>
                    <Container>
                         <Row className="p-2">
                              <Col className="shadow-sm bg-white mt-2" md={12} lg={12} sm={12} xs={12}>

                                   <Row className="text-center">
                                        <Col className="d-flex justify-content-center" md={6} lg={6} sm={12} xs={12}>
                                             <Form className="onboardForm" onSubmit={this.formSubmit} >
                                                  <h4 className="section-title-login"> USER SING IN </h4>

                                                  <input className="form-control m-2" type="email" placeholder="Enter Your Email" onChange={(e) => { this.setState({ email: e.target.value }) }} />

                                                  <input className="form-control m-2" type="password" placeholder="Enter Your Password" onChange={(e) => { this.setState({ password: e.target.value }) }} />


                                                  <Button type="submit" className="btn btn-block m-2 site-btn-login"> Login </Button>

                                                  <br></br> <br></br>
                                                  <hr />
                                                  <p> <b> Forget My Password? </b><Link to="/forget"><b> Froget Password </b> </Link> </p>

                                                  <p> <b> Don't Have An Account ? </b><Link to="/register"><b> Register </b> </Link> </p>

                                             </Form>


                                        </Col>

                                        <Col className="p-0 Desktop m-0" md={6} lg={6} sm={6} xs={6}>
                                             <img className="onboardBanner" src={Login} />
                                        </Col>
                                   </Row>






                              </Col>
                         </Row>
                    </Container>
               </Fragment>
          )
     }
}

export default UserLogin
